import { useIntl } from 'react-intl';

import { deckPath, type DeckSummary } from '../lib/decks.ts';
import { Card, CardContent } from './ui/card.tsx';

export function DeckList({ decks }: { decks: DeckSummary[] }) {
  const intl = useIntl();
  return (
    <section className="mt-4 grid gap-4">
      <div className="grid gap-3">
        {decks.map((deck) => (
          <article key={deck.id}>
            <a
              className="block rounded-lg active:translate-y-px"
              href={deckPath(deck.slug)}
            >
              <Card className="border border-border bg-card text-card-foreground shadow-[0_8px_18px_rgb(23_22_20_/_0.06)] transition hover:border-foreground">
                <CardContent className="flex items-center justify-between gap-4 max-[560px]:items-stretch max-[560px]:flex-col">
                  <h2 className="m-0 overflow-wrap-anywhere font-sans text-[1.35rem] font-normal [text-wrap:balance]">
                    {deck.title}
                  </h2>
                </CardContent>
              </Card>
            </a>
          </article>
        ))}
      </div>
    </section>
  );
}
